import React from 'react'

import { Button, FormattedHTMLMessage, Spinner } from '@web/walter-ui-kit'
import s from './s.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'

interface Props {
    onClose: () => void
}

function Pending({ onClose }: Props) {
    return (
        <ModalView
            img={
                <div className={s.loader}>
                    <Spinner intent="accent" size={64} />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.title} />}
            subtitle={<FormattedHTMLMessage {...lang.subtitle} />}
            dataPointer="status_pending"
        >
            <Button dataPointer="button" size="l" mode="primary" onClick={onClose} fullWidth>
                <FormattedHTMLMessage {...lang.button} />
            </Button>
        </ModalView>
    )
}

export default Pending
